import React from 'react';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';

class IconWithLabel extends React.Component {
    renderIcon(icon) {
        if (icon.type === 'svg') {
            return <Isvg src={icon.src} />;
        }

        return <img src={icon.src} alt={this.props.label} className={icon.class} />;
    }

    render() {
        const { extraClasses } = this.props;
        const classes = ['icon-w-label'].concat(extraClasses);
        return (
            <div className={classes.join(' ')} onClick={this.props.onClick}>
                {this.props.iconActive ? (
                    <div className="icon is-toggleable">
                        {this.renderIcon(this.props.icon)}
                        {this.renderIcon(this.props.iconActive)}
                    </div>
                ) : (
                    <div className="icon">{this.renderIcon(this.props.icon)}</div>
                )}
                <span className="label">{this.props.label}</span>
            </div>
        );
    }
}

IconWithLabel.propTypes = {
    icon: PropTypes.object.isRequired,
    iconActive: PropTypes.object,
    label: PropTypes.node.isRequired,
    onClick: PropTypes.func,
    extraClasses: PropTypes.array,
};

IconWithLabel.defaultProps = {
    onClick: undefined,
    extraClasses: [],
};

export default IconWithLabel;
